"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const semantic_json_1 = require("@hediet/semantic-json");
const semantic_json_2 = require("@hediet/semantic-json");
exports.cliNs = semantic_json_1.namespace("hediet.de/cli");
const sNamespacedName = semantic_json_1.sObject({
    properties: {
        namespace: semantic_json_1.sString,
        name: semantic_json_1.sString,
    },
}).refine({
    canSerialize: (ns) => ns instanceof semantic_json_1.NamespacedName,
    deserialize: ns => semantic_json_2.deserializationValue(new semantic_json_1.NamespacedName(ns.namespace, ns.name)),
    serialize: ns => ({
        namespace: ns.namespace,
        name: ns.name,
    }),
});
exports.sSchema = semantic_json_1.sObject({
    properties: {
        mainType: sNamespacedName,
        defaultType: semantic_json_1.field({ serializer: sNamespacedName, optional: true }),
        typePackages: semantic_json_1.sArray(semantic_json_1.sTypePackage),
    },
});
function cliToSchema(cli) {
    const ts = new semantic_json_1.TypeSystem();
    const serializer = cli.getSerializer();
    const tp = serializer.getType(ts);
    const typePackages = ts.definedPackages();
    return {
        mainType: tp.namespacedName,
        typePackages,
    };
}
exports.cliToSchema = cliToSchema;
class InstantiatedCmd {
    constructor(getData) {
        this.getData = getData;
    }
}
exports.InstantiatedCmd = InstantiatedCmd;
//# sourceMappingURL=schema.js.map